import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { usePreviewOverflow } from '@/composables/format-edit/usePreviewOverflow'
import { formatPreviewCreateDate } from '@/utils/format-edit/previewDates'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterPreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const { formLib } = useHostServices()
const { scaleStyle, highlightMessage, goCardTo, highLightClass } =
  useFormatPreview(props)

const introSummary = ref<HTMLElement | null>(null)
const resumeSummary = ref<HTMLElement | null>(null)
const entrySummary = ref<HTMLElement | null>(null)
const overflowEls: Record<string, typeof introSummary> = {
  introSummary,
  resumeSummary,
  entrySummary
}

const { classObject, adjustFontSize } = usePreviewOverflow({
  getEl: (name) => overflowEls[name]?.value ?? undefined,
  maxHeights: {
    introSummary: 90,
    resumeSummary: 90,
    entrySummary: 210
  },
  watchSources: [
    { name: 'introSummary', source: () => props.formatData?.introSummary },
    { name: 'resumeSummary', source: () => props.formatData?.resumeSummary },
    { name: 'entrySummary', source: () => props.formatData?.entrySummary }
  ]
})

const formatedCreateDate = computed(() =>
  formatPreviewCreateDate(
    props.formatData?.createDate,
    formLib.dateFormat,
    'placeholder'
  )
)

function checkValid() {
  adjustFontSize('introSummary')
  adjustFontSize('resumeSummary')
  adjustFontSize('entrySummary')
}

expose({ checkValid })

return { __sfc: true,props, formLib, scaleStyle, highlightMessage, goCardTo, highLightClass, introSummary, resumeSummary, entrySummary, overflowEls, classObject, adjustFontSize, formatedCreateDate, checkValid }
}

})